import type { AdminAuthErrorCode } from '@/contracts';

/**
 * The login form's state — the three steps sign-in can be in.
 *
 * The shape is unchanged from the server-action version, and so is the reason it
 * is one union rather than a bag of booleans: the password step and the TOTP
 * step hold different data, and `challengeToken` existing is exactly what tells
 * them apart. Enrolment is a variant of the second step and not a fourth, because
 * an admin enrolling still answers the same field.
 */
export type AdminLoginState =
  | { step: 'password'; error?: AdminAuthErrorCode; retryAfterSeconds?: number }
  | {
      step: 'totp' | 'enrol';
      challengeToken: string;
      /** Enrolment only: the base32 key, pre-grouped for transcription. */
      totpSecret?: string;
      totpUri?: string;
      error?: AdminAuthErrorCode;
    };

export const INITIAL_LOGIN_STATE: AdminLoginState = { step: 'password' };
